import * as React from 'react';
import './Panel.scss';

interface PanelProps extends React.HTMLAttributes<HTMLDivElement> {
  title?: string;
  action?: any;
}

const Panel: React.FC<PanelProps> = ({ title, action, children, ...props }) => {
  return (
    <div className="Panel">
      {title && <h3>{title}</h3>}
      <div>{children}</div>
    </div>
  );
};

export default Panel;
